<template>
  <div class="name-profile">
    <div class="name">TUSHAR KSHIRSAGAR</div>
    <div class="profile">FRONT END DEVELOPER</div>
  </div>
</template>

<script>
export default {
  name: "NameProfile"
};
</script>

<style lang="scss" scoped>
.name-profile {
  margin: 1rem 0 4rem 0;

  .name {
    font-size: 2.5rem;
    font-weight: bold;
  }
  .profile {
    font-size: 1rem;
    letter-spacing: 0.4rem;
    margin: 1rem 0;
    font-weight: bold;
  }
}
</style>
